import React, { PureComponent, useState } from 'react';

import ModalContainer from './../../../../components/shared/modal/ModalContainer';
import { PrimaryButton, StyledRow, SecundaryButton } from './../../../../components/shared/sharedStyles.styles';
import { Container, SpanTitle, GrayText } from '../../../operational/request/form/fieldModal/formModalFields.styled';
import LoadingCircle from '../../../../components/shared/treatedIcons/LoadingCircle';
import Loading from '@bit/wavfichacerta.fichacerta.icons.loading';
import styled from 'styled-components';

export const Wrapper = styled.div`
  label {
    display: block;
    width: 37px;
  }

  textarea {
    height: 24px;
    width: 100%;
    border: none;
    outline: none;
    border-bottom: 1px solid #7f7f7f91;
  }

	.btn-nps {
		cursor: pointer;
	}

	.btn-nps.selected:after {
		border: 2px solid black;
    content: '';
    position: absolute;
    width: 36px;
    height: 36px;
    border-radius: 7px;
	}
`;

const EscalaNps = ({ selectedValue, target }) => {
	const [selected, setSelected] = useState('');
	const scalas = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

	const bgColor = (scala) => {
		switch(scala) {
			case 0:
				return '#c52220';
			case 1:
				return '#ea3432';
			case 2:
				return '#f74445';
			case 3:
				return '#ff6443';
			case 4:
				return '#ff8538';
			case 5:
				return '#ffa52a';
			case 6:
				return '#ffc000';
			case 7:
				return '#e3c400';
			case 8:
				return '#9dcb00';
			case 9:
				return '#79ca00';
			case 10:
				return '#32ae00';
		}
	}

	const handleClick = (scala) => {
		selectedValue({value: scala, target});
		setSelected(scala);
	}

	return (
		<div style={{ display: 'flex', justifyContent: 'center', color: '#fff' }}>
			{
				scalas.map(scala => (
					<div
						onClick={() => handleClick(scala)}
						className={`btn-nps ${selected === scala && 'selected'}`}
						style={{ border: '1px solid transparent', width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 5, fontWeight: 500, marginRight: 7, backgroundColor: bgColor(scala) }}
					>
						{scala}
					</div>
				))
			}
		</div>
	)
}

class ModalPesquisaNps extends PureComponent {

	constructor(props) {
    super(props);
    this.state = {
			inputSelectedNps: {
				usabilidade_plataforma: null,
				tempo_laudo: null,
				formato_laudo: null,
				compreensao_laudo: null,
				suporte_cliente: null,
				voce_indicaria: null,
				sugestao: null
			}
		};
  }

	componentWillUnmount() {
		console.log('DESMOTANDO MODAL PRINT')
	}

	renderFooter = () => {
		if (this.props.loading || this.props.error || this.props.success) {
			return null
		}

		const currentNumber = this.props.currentNumber

		return (
			<StyledRow padding='0 3em' justify="space-around">
				<PrimaryButton data-testid="send-data-button" onClick={this.props.replyLater}>Responder depois</PrimaryButton>
				{currentNumber === 3 && <PrimaryButton data-testid="send-data-button" onClick={this.props.dontReply}>Não quero responder</PrimaryButton>}
				<PrimaryButton data-testid="go-back-button" onClick={() => this.props.sendNpsForApi(this.state.inputSelectedNps)} disabled={this.validation() === false ? true : false}>Enviar</PrimaryButton>
			</StyledRow>
		)
	}

	renderHeader = () => {
		if (this.props.success) {
			return null
		}

		return (
			<SpanTitle customstyle="margin: auto;">
				{/* Olá {this.props.nome} você experimentou o Tour FC ANALISE. */}
				Contamos com você! Por favor, avalie de 0 a 10 os seguintes aspectos do nosso serviço:
			</SpanTitle>
		)
	}

	selectEscala = ({value, target}) => {
		console.log("value", value)
		console.log('target', target)
		this.setState({
			inputSelectedNps: {
				...this.state.inputSelectedNps,
				[target]: value
			}
		})
	}

	changeSugestao = (e) => {
		this.setState({
			inputSelectedNps: {
				...this.state.inputSelectedNps,
				sugestao: e.target.value
			}
		})
	}

	validation = () => {
		let isValid = true;
		console.log('nps>>', this.state.inputSelectedNps)
		Object.keys(this.state.inputSelectedNps).map(key => {
			if (this.state.inputSelectedNps[key] === null && key !== 'sugestao') {
				isValid = false;
			}
		})
		return isValid;
	}

	renderNpsUsabilidade = () => {
		return (
			<React.Fragment>
				<p><b>Usabilidade da plataforma</b> (facilidade de uso, navegação, clareza):</p>
				<EscalaNps selectedValue={this.selectEscala} target='usabilidade_plataforma' />
			</React.Fragment>
		)
	}

	renderNpsTempoRetornoLaudo = () => {
		return (
			<React.Fragment>
				<p><b>Tempo de retorno do laudo</b> (agilidade na entrega dos resultados):</p>
				<EscalaNps selectedValue={this.selectEscala} target='tempo_laudo' />
			</React.Fragment>
		)
	}

	renderNpsFormatoLaudo = () => {
		return (
			<React.Fragment>
				<p><b>Formato do laudo</b> (apresentação, organização, visual):</p>
				<EscalaNps selectedValue={this.selectEscala} target='formato_laudo' />
			</React.Fragment>
		)
	}

	renderNpsCompreensaoLaudo = () => {
		return (
			<React.Fragment>
				<p><b>Compreensão do laudo</b> (clareza das informações, linguagem utilizada):</p>
				<EscalaNps selectedValue={this.selectEscala} target='compreensao_laudo' />
			</React.Fragment>
		)
	}

	renderNpsSuporteCliente = () => {
		return (
			<React.Fragment>
				<p><b>Suporte ao cliente</b> (atendimento, disponibilidade, resolução de dúvidas):</p>
				<EscalaNps selectedValue={this.selectEscala} target='suporte_cliente' />
			</React.Fragment>
		)
	}

	renderNpsIndicariaFc = () => {
		return (
			<React.Fragment>
				<p><b>Você indicaria a FC ANALISE para um(a) amigo(a) ou imobiliária parceira?</b></p>
				<EscalaNps selectedValue={this.selectEscala} target='voce_indicaria' />
			</React.Fragment>
		)
	}

	renderBody = () => {
		if (this.props.error) {
			return 'Ocorreu um erro interno ao enviar sua avaliação. Se persistir o erro, contate a FC ANALISE.'
		}
		if (this.props.success) {
			return <p style={{ marginBottom: 0, marginTop: 15 }}>Agradecemos sua participação {this.props.nome}, seu feedback é fundamental para a FC ANALISE</p>
		}

		return (
			<Wrapper>
				{this.renderNpsUsabilidade()}
				<hr />

				{this.renderNpsTempoRetornoLaudo()}
				<hr />

				{this.renderNpsFormatoLaudo()}
				<hr />

				{this.renderNpsCompreensaoLaudo()}
				<hr />

				{this.renderNpsSuporteCliente()}
				<hr />

				{this.renderNpsIndicariaFc()}
				<hr />

				<br />
				<br />
				<div>
					<p><b>Tem alguma sugestão, crítica ou comentário que gostaria de compartilhar?</b></p>
					<textarea name='sugestao' onChange={this.changeSugestao} maxlength="300" style={{resize: 'none', fieldSizing: 'content', height: 'auto'}} data-rows="2" tabindex="0" placeholder="Sua resposta" aria-label="Sua resposta" dir="auto" data-initial-dir="auto" data-initial-value="" badinput="false"></textarea>
					<div style={{float: 'right', color: this.state.inputSelectedNps.sugestao && this.state.inputSelectedNps.sugestao.length === 300 && 'red'}} className={`${this.state.inputSelectedNps.sugestao && this.state.inputSelectedNps.sugestao.length === 300 && 'headShake'}`}>{this.state.inputSelectedNps.sugestao && this.state.inputSelectedNps.sugestao.length || 0}/300</div>
				</div>
			</Wrapper>
		)
	}

	renderLoading = () => {
		if (this.props.loading) {
			return <div style={{ marginTop: 20, marginBottom: -10 }}>
				<Loading width="30px" height="30px" margin="0 auto" color="color_border-gray" />
			</div>
		}
	}

	render() {
		return (
			<ModalContainer
				isOpen={this.props.isOpen}
				size="md"
				showCloseIcon={this.props.success}
				onClose={this.props.onClose}
				footer={this.renderFooter()}
				header={this.renderHeader()}
				customstyle='
          @media (max-width: 800px) {
            h5 {
              font-weight: 400;
            }
          }

          max-width: 640px;
        '
				customstyleModalFooter='
          @media (max-width: 800px) {
            button {
              width: 121px;
              height: 33px;
              font-size: .88rem;
              background-color: #152b4e;
              padding: 0;
              margin-top: 0;
              margin: 0 9px;
            }

            .row {
              justify-content: center;
              padding: 0;
            }
          }

          button:disabled,
          button:disabled:hover {
            background: #7f7f7f;
          }
        '
			>

				<Container
					customstyle="
            text-align: center;
            margin: 20px auto;

            span {
              font-size: 12px;
              font-weight: 400 !important;
            }

            @media (max-width: 800px) {
              margin: 10px auto;
            }
          "
				>
					<GrayText style={{ fontSize: 14 }}>
						{this.renderBody()}
					</GrayText>
					{this.renderLoading()}
				</Container>

			</ModalContainer>
		);
	}
}

export default ModalPesquisaNps;